import {IBienLaiViewTuyenSinhActionTypes} from "../../action-types/bien-lai/IBienLaiViewTuyenSinhActionTypes";
import {
    IBienLaiViewThiSinhReducer,
    IBienLaiViewTuyenSinhReducer,
} from "../../reducer-model/bien-lai/IBienLaiViewTuyenSinhReducer";
import {eReducerStatusBase} from "../../reducer-model/eReducerStatusBase";

const iniState: IBienLaiViewTuyenSinhReducer = {
    thiSinhs: [],
};
export const bienLaiViewTuyenSinhReducer = (
    state: IBienLaiViewTuyenSinhReducer = iniState,
    action: IBienLaiViewTuyenSinhActionTypes
): IBienLaiViewTuyenSinhReducer => {
    switch (action.type) {
        case "BIEN_LAI_VIEW_TUYEN_SINH_LOAD_START":
            const resquest = action.payload;
            const {id_thi_sinh, nam_tuyen_sinh} = resquest;
            const sinhVienReducerExisted = state.thiSinhs.find(
                (x) => x.idThiSinh === id_thi_sinh && x.namTuyenSinh === nam_tuyen_sinh
            );
            const sinhVienReducer: IBienLaiViewThiSinhReducer =
                sinhVienReducerExisted ?? {
                    bienLais: [],
                    idThiSinh: id_thi_sinh,
                    namTuyenSinh: nam_tuyen_sinh,
                    status: eReducerStatusBase.is_loading,
                };
            return {
                ...state,
                thiSinhs: [
                    sinhVienReducer,
                    ...state.thiSinhs.filter(
                        (x) =>
                            x.idThiSinh !== id_thi_sinh && x.namTuyenSinh !== nam_tuyen_sinh
                    ),
                ],
            };
        case "BIEN_LAI_VIEW_TUYEN_SINH_LOAD_SUCCESS":
            return {
                ...state,
                thiSinhs: state.thiSinhs.map((sv) => {
                    if (
                        sv.idThiSinh === action.payload.request.id_thi_sinh &&
                        sv.namTuyenSinh === action.payload.request.nam_tuyen_sinh
                    ) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_completed,
                            bienLais: action.payload.data,
                        };
                    }
                    return sv;
                }),
            };
        case "BIEN_LAI_VIEW_TUYEN_SINH_LOAD_ERRR":
            return {
                ...state,
                thiSinhs: state.thiSinhs.map((sv) => {
                    if (
                        sv.idThiSinh === action.payload.request.id_thi_sinh &&
                        sv.namTuyenSinh === action.payload.request.nam_tuyen_sinh
                    ) {
                        return {
                            ...sv,
                            status: eReducerStatusBase.is_completed,
                            bienLais: [],
                        };
                    }
                    return sv;
                }),
            };
        default:
            return state;
    }
};
